export default __webpack_public_path__ + "static/ivan-bace79455135b0f0ecd20295f6bec1c2.jpg";